import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import IconTitleGridContactPromo from "../../design-system/templates/icon-title-grid-contact-promo"


const OurCommitmentContactPromo = () => {
  const query = useStaticQuery(graphql`
    query {
      bulletSrc: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/check_mark_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const imgElement = <img src={query.bulletSrc.publicURL} alt="" />

  const gridItems = [
    { title: "Joint product offerings", icon: imgElement },
    { title: "Go-to-market resources", icon: imgElement },
    { title: "Dedicated partner manager", icon: imgElement },
    { title: "Developer support", icon: imgElement },
    { title: "Regular check-ins", icon: imgElement },
    { title: "Lead sharing", icon: imgElement },
  ]

  return (
    <IconTitleGridContactPromo
      title="Our Commitment"
      description="          Mappedin is dedicated to investing in your success as a partner. We
          will equip you with the tools and support required to add value to
          your business and the businesses we serve together.
          "
      gridItems={gridItems}
    />
  )
}

export default OurCommitmentContactPromo;
